import {DoraProperty} from '../../../Decorators/Decorator';

export class TabElement {
    @DoraProperty
    name: string;
    @DoraProperty
    elementReferenceId: string;
    // tslint:disable-next-line:variable-name
    private _active = false;

    constructor(name: string = '', elementReferenceId: string = '', active: boolean = false) {
        this.name = name;
        this.elementReferenceId = elementReferenceId;
        this._active = active;
    }

    get active(): boolean {
        return this._active;
    }

    set active(value: boolean) {
        this._active = value;
    }
}
